import { List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { NavLink } from "react-router-dom";

import { visitorManagementPrimaryNav } from "./visitorManagementPrimaryNav";

const listItemButtonGridSx = {
  display: "grid",
  gap: "1rem",
  gridAutoColumns: "auto 1fr auto",
  gridAutoFlow: "column",
} as const;

export function VisitorManagementSideNav() {
  return (
    <List
      component="nav"
      sx={{
        flex: "1 1 auto",
        minHeight: 0,
        overflow: "auto",
        pt: 0.5,
        px: 0,
        py: 0,
      }}
    >
      {visitorManagementPrimaryNav.map(({ Icon, ...item }) => (
        <ListItemButton
          key={item.label}
          component={NavLink}
          end={item.end}
          sx={{
            ...listItemButtonGridSx,
            borderRadius: "0.25rem",
            mx: 1,
            my: 0.25,
          }}
          to={item.to}
        >
          <ListItemIcon sx={{ minWidth: "unset" }}>
            <Icon fontSize="medium" />
          </ListItemIcon>
          <ListItemText>{item.label}</ListItemText>
        </ListItemButton>
      ))}
    </List>
  );
}
